import loadable from '@loadable/component';

import './Achievements.css';

export default loadable(() => {
  return import('./Achievements.jsx');
});
